// Define Vue feature flags
window.__VUE_OPTIONS_API__ = process.env.VUE_OPTIONS_API === 'true'
window.__VUE_PROD_DEVTOOLS__ = process.env.VUE_PROD_DEVTOOLS === 'true'
// window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = process.env.VUE_PROD_HYDRATION_MISMATCH_DETAILS === 'true'

// 注意：如果用import导入，要导入esm版本的js文件。
import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index.js'
import i18n from '../lang/index.js'
import pinia from './store'
import '../styles/page.css'
import '../styles/mdb.min.css'
import '../styles/flatpickr.min.css'
import '../styles/multiselect.min.css'
import 'mdb-vue-ui-kit/css/mdb.min.css';
import 'element-plus/dist/index.css'
import ElementPlus from 'element-plus'
import ModalPlugin from './components/common/Modal/ModalService.js'
import FormPlugin from './components/common/Form'
import { getElementPlusLocale } from '../lang/index.js'
import globalComponents from './plugins/globalComponents.js'
import globalPropertiesPlugin from './plugins/globalproperties.js'
import truncateTooltipDirective from '../scripts/directives/truncateTooltip.js'
// 如果有图标更新，记得复制最新的文件到iconfont.js
import '../scripts/iconfont_admin.js'
const app = createApp(App)


// 使用插件
app.use(router)
app.use(i18n) 
app.use(pinia)
app.use(ElementPlus, {
  locale: getElementPlusLocale() 
})
app.use(ModalPlugin)
app.use(FormPlugin)
app.use(globalComponents) 
app.use(globalPropertiesPlugin) // 使用全局属性插件
app.use(truncateTooltipDirective) // 全局指令 v-truncate-tooltip

app.mount('#vue-app')
